import React from "react";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import MDBox from "../materialDashboard/components/MDBox";


export const useRightDrawer = () => {
    const [isOpen, setIsOpen] = React.useState(false);

    const close = () => {
        setIsOpen(false);
    }

    const open = () => {
        setIsOpen(true);
    }

    const toggle = () => {
        setIsOpen(state => !state);
    }

    return {isOpen, open, close, toggle};
}


const RightDrawer = ({title, open, onClose, children}) => {

    return <Drawer open={open} onClose={onClose} anchor="right" PaperProps={{sx: { width: "min-content", maxWidth: "75%" }}}>
        <MDBox p={2} sx={{position: "sticky", top: 0, background: "white", zIndex: 10}}>
            <IconButton size="small"
                        disableRipple
                        color="inherit"
                        aria-controls="notification-menu"
                        variant="contained"
                        onClick={onClose}
            >
                <Icon>close</Icon>
            </IconButton>
            { title }
        </MDBox>
        {children}
    </Drawer>
}

export default RightDrawer;